export const device = {
  sm: `(min-width: 768px)`,
  maxSm: `(max-width: 768px)`,
  maxXs: `(max-width: 480px)`,
  hsm: `(max-height: 700px)`,
  md: `(min-width: 992px)`,
  lg: `(min-width: 1200px)`,
  xl: `(min-width: 1366px)`,
};
